import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const layoutReducer = (state: RootState) => state.layout;

export const layoutSidebarToggleSelector = createSelector(layoutReducer, (state) => state.sidebarToggled);
